import React from 'react'
import {
  AutocompleteInput,
  Create,
  SimpleForm,
  TextInput,
  RadioButtonGroupInput,
  required,
  minLength,
  ReferenceInput,
  email,
  BooleanInput,
  useTranslate,
  FormDataConsumer,
  useGetOne,
} from 'react-admin'

import { SxProps } from '@mui/material'
import { PERMISSIONS } from '../../constants'
import Permission from '../../components/Permission'
import { filterToQuery } from '../../utils'
import { EmailVerificationInfoAlert } from '../../components/EmailVerificationAlerts'

const profilesSx: SxProps = {
  width: 220,
};

const validatePassword = [required(), minLength(6)]
const validateEmail = [required(), email()]

const PlaceProfilesInput = ({ placeId }: { placeId?: string }) => {
  const { data: place } = useGetOne(
    'places',
    { id: placeId },
    { enabled: !!placeId },
  );
  return (
    <ReferenceInput
      sx={profilesSx}
      source="profileId"
      reference="profiles"
      sort={{ field: 'name', order: 'ASC' }}
      perPage={9999}
      filter={place?.chainId ? { chainId: place.chainId } : undefined}>
      <RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
    </ReferenceInput>
  );
};

export default props => {
  const translate = useTranslate();

  return (
    <Permission permission={PERMISSIONS.CREATE_LOCAL_USER}>
      <Create {...props} title="Cadastrar novo usuário">
        <SimpleForm sx={{ maxWidth: 600 }}>
          <ReferenceInput
            reference="places"
            source="placeId"
            sort={{ field: "name", order: "ASC" }}
            perPage={null}
            >
            <AutocompleteInput 
              filterToQuery={filterToQuery} 
              label="Parceiro ou Posto" 
              optionText="name" 
              isRequired
              validate={required()} 
              sx={{ minWidth: 220 }}
              noOptionsText={translate('ra.input.autocomplete.no_options_text')}
              />
          </ReferenceInput>
          <TextInput source="name" label="Nome" validate={[required()]} sx={{ minWidth: 220 }} InputProps={{ autoComplete: 'off' }} />
          <TextInput source="login" label="Login" validate={validateEmail} sx={{ minWidth: 220 }} InputProps={{ autoComplete: 'off' }} />
          <TextInput
            InputProps={{ autoComplete: 'new-password' }}
            source="password"
            label="Senha"
            validate={validatePassword}
            sx={{ minWidth: 220 }}
          />
          <FormDataConsumer>
            {({ formData }) => <PlaceProfilesInput placeId={formData.placeId} />}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
          <EmailVerificationInfoAlert />
        </SimpleForm>
      </Create>
    </Permission>
  )
}
